import { useReport } from "./hooks/use-context";

export function Header({sectionName}: {sectionName: string}) {
  const { header } = useReport();

  return (
    <div
      style={{
        maxWidth: '950px',
        marginBottom: '12px',
        color: '#000',
      }}
    >
      <div
        style={{
          borderBottom: '2px solid #DEC8B3',
          marginBottom: '12px',
        }}
      >
        <div
          style={{
            marginBottom: '10px',
            padding: '10px',
            background: 'linear-gradient(to right, #F6F4F1, #5ECC85)',
          }}
        >
          <img src={header.logo} alt="Goiasa" width={75} height={25} />
          {/* <span style={{ color: '#1d6737', fontSize: '18px' }}>Goiasa</span> */}
        </div>
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '16px',
            padding: '4px 10px',
            marginBottom: '10px',
          }}
        >
          {sectionName?.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
